import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldConfig } from '../field.interface';
@Component({
  selector: 'c4dweb-radiobutton',
  template: `
    <ng-container *ngIf="group != null">
      <div class="demo-full-width margin-top" [formGroup]="group">
        <label class="radio-label-padding"
          >{{ field.label.toUpperCase() }}:</label
        >
        <mat-radio-group [formControlName]="field.name" >
          <mat-radio-button
            *ngFor="let item of field.options"
            [value]="item.options"
            (change)="changeValue(field?.name,$event)"
            >{{ item.options }}</mat-radio-button
          >
        </mat-radio-group>
      </div>
    </ng-container>

    <ng-container *ngIf="group == null">
      <div class="demo-full-width margin-top">
        <label class="radio-label-padding">{{ field.label }}:</label>
        <mat-radio-group>
          <mat-radio-button
            *ngFor="let item of field.options"
            [value]="item.options"
            >{{ item.options }}</mat-radio-button
          >
        </mat-radio-group>
      </div>
    </ng-container>
  `,
  styles: [],
})
export class C4dWebRadiobuttonComponent implements OnInit {
  field: FieldConfig;
  group: FormGroup;

  @Output() eventChange: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }
  ngOnInit(): void { }

  changeValue(id, $event): void {
    let strValue = '';
    if (this.group != null) {
      strValue = this.group?.get(id)?.value;
    } else {
      strValue = $event;
    }
    const ret = {
      fieldId: id,
      value: strValue,
    };
    this.eventChange.emit(ret);
  }
}
